import type { CreateOrderData } from '../../../api/order';
import type { VestmentType } from '../../enum/vestmentType';
import { getCategory } from '../../enum/vestmentType';
import { ORDER_ITEM_REGISTRY, emptyOrderItemFormValues } from './registry';
import type { OrderItemFormValues } from './types';

export type {
  AlbItemFormValues,
  BaseLineItemFormValues,
  ChasubleItemFormValues,
  MitreItemFormValues,
  OrderItemCategoryConfig,
  OrderItemCategoryDialog,
  OrderItemDialogSlotProps,
  OrderItemFormValues,
  OrderItemSummaryContext,
  OrderItemSummarySegment,
  StoleItemFormValues,
} from './types';

export type { OrderItemSizeSummaryParams } from './helpers';

export {
  formatMaterialLabel,
  formatOrderItemSizeSummary,
  getMaterialSummary,
  getChasubleMaterial,
  getChasubleMaterialSummary,
  getFormValuesCategory,
  getVestmentsByCategory,
  syncDesignWithCode,
} from './helpers';

export {
  defaultPanelLength,
  defaultPanelWidth,
  displayMeasurement,
  getMeasurementPlaceholder,
} from './defaults';

export { ORDER_ITEM_REGISTRY, emptyOrderItemFormValues };

export function buildOrderItemPayload(
  item: OrderItemFormValues,
  vestmentTypes: Map<string, VestmentType>
): CreateOrderData['items'][number] {
  const vestmentType = vestmentTypes.get(item.vestment);
  if (!vestmentType) {
    throw new Error('Missing vestment type for order item.');
  }
  return ORDER_ITEM_REGISTRY[getCategory(vestmentType)].formToPayload(
    item,
    vestmentType
  );
}

export function buildOrderPayload(
  customer: number,
  dueDate: string | undefined,
  notes: string | undefined,
  items: OrderItemFormValues[],
  vestmentTypes: Map<string, VestmentType>
): CreateOrderData {
  return {
    customer,
    dueDate: dueDate?.trim() || undefined,
    notes: notes?.trim() || undefined,
    items: items.map((item) => buildOrderItemPayload(item, vestmentTypes)),
  };
}
